<script>
    import { lang } from "../scripts/stores";
    import { fade, fly } from "svelte/transition";
    import Overlay from "./Overlay.svelte";

    export let show;
</script>

{#if show}
    <div class="svelte-modal" in:fly={{ duration: 200, y: 200 }} out:fade={{ duration: 200 }}>
            <label class="label" for="lang">
                <b>
                    <span class="label-text settings-label">Valitse kieli / Select language</span>
                </b>
            </label>   

            <select id="lang" class="select select-bordered w-full max-w-xs" style="margin-bottom: 1.5rem;" bind:value={ $lang }>
                <option value="fi">suomi</option> 
                <option value="en">english</option> 
            </select>

            <button class="btn btn-primary" on:click={ () => show = false }>
                Valitse / Select
            </button>
    </div>

    <Overlay show={ show } on:click={ () => show = false } />
{/if}

<style>
    .svelte-modal {
        background: #fff;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 480px;
        max-width: 85%;
        height: fit-content;
        max-height: 80%;
        padding: .8rem;
        background: #fff;
        text-align: center;
        font-size: 18px;
        overflow-y: auto;
        z-index: 300;
        border: 1px solid gray;
        border-radius: 20px;
    }
    select {
        margin-top: 1.5rem;
    }
</style>